import { axiosInstance } from ".."

const projectsList = async (query) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/mmhprojects?${query}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default projectsList;